import type { NextPage } from "next";
import SavedScreen from "@components/Screens/SavedScreen/SavedScreen";
import Template from "@app/Template/Template";
import { PROJECT_NAME } from "@shared/config/GlobalText";
import { configApi } from "@shared/lib/configApi";
import { RouterConfig } from "@shared/lib/routerConfig";
import { CustomHead, DEFAULT_OG_IMAGE } from "@shared/ui/CustomHead";

const Saved: NextPage = () => {
    const title = `${PROJECT_NAME} - избранное`;
    const description = `${PROJECT_NAME} - избранное`;
    const canonicalUrl = `${configApi.API_PUBLIC_DOMAIN}${RouterConfig.FAVORITES}`;

    return (
        <Template>
            <CustomHead
                title={title}
                description={description}
                robots={"index,follow"}
                canonical={canonicalUrl}
                openGraph={{
                    title: title,
                    description: description,
                    url: canonicalUrl,
                    type: "website",
                    image: {
                        url: DEFAULT_OG_IMAGE,
                        alt: title
                    }
                }}
            />
            <SavedScreen />
        </Template>
    );
};

export default Saved;